import React from 'react';

const EducatorSupport = () => {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Support</h1>
      <p className="text-gray-600">Support center coming soon...</p>
    </div>
  );
};

export default EducatorSupport;